export const I18n = {
	'en': {
		attributes: 'App attributes',
		visibility: 'Visibility for companies:',
		selectCompanyByName: 'Select by name...',
		addCompany: 'add Company',
		apk: ' APK: ',
		active: 'Active',
		commercial: 'Commercial',
		download: 'Download',
		edit: 'Edit',
		info: 'Info',
		delete: 'Delete',
		cancelSelection: 'Сancel selection',
		makeActive: 'Make active',
		arch: 'Architecture:',
		operatorCompany: 'Operator company',
		modals: {
			sure: 'A you sure ?',
			delete: 'Delete',
			cancel: 'Cancel',
			companyRemove: 'Companies - delete',
			companyAdd: 'Companies - add',
			companiesList: 'Companies List'
		}

	},
	'ru': {
		attributes: 'Атрибуты приложения',
		visibility: 'Видимость для компаний:',
		selectCompanyByName: 'Выбор по имени...',
		addCompany: 'Добавить компанию',
		apk: 'АПК: ',
		active: 'Активный',
		commercial: 'Рекламный',
		download: 'Скачать',
		edit: 'Редактировать',
		info: 'Информация',
		delete: 'Удалить',
		cancelSelection: 'Отменить выбор',
		makeActive: 'Сделать активным',
		arch: 'Aрхитектура:',
		operatorCompany: 'Компания оператора',
		modals: {
			sure: 'Вы уверены ?',
			delete: 'Удалить',
			cancel: 'Отмена',
			companyRemove: 'Компании - удалить',
			companyAdd: 'Компании - добавить',
			companiesList: 'Список компаний'
		}
	},
	'sk': {
		attributes: 'Atribúty App',
		visibility: 'Viditeľnosť pre firmy:',
		selectCompanyByName: 'Vybrať podľa názvu ...',
		addCompany: 'Pridať firmu',
		apk: 'APK: ',
		active: 'Aktívny',
		commercial: 'Komerčný',
		download: 'Stiahnuť ▼',
		edit: 'Editovať',
		info: 'Info',
		delete: 'Vymazať',
		cancelSelection: 'Voľba Сancel',
		makeActive: 'Nastaviť ako aktívny',
		arch: 'Architektúra:',
		operatorCompany: 'Operátorská spoločnosť',
		modals: {
			sure: 'A Je to iste?',
			delete: 'Vymazať',
			cancel: 'Zrušiť',
			companyRemove: 'FIRMY - zmazať',
			companyAdd: 'FIRMY - pridať',
			companiesList: 'Zoznam firiem'
		}
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/application/index.js